export default __webpack_public_path__ + "media/Jira_mobile.b4450ab6532cbd4efcd56341f9ad0cc1.svg";